import React from 'react'
import PropTypes from 'prop-types'

import TopBottomToggleOption from './top-bottom-toggle-option'

const TopBottomToggle = ({ value, changeHandler }) => (
  <div className="top-bottom__options">
    <TopBottomToggleOption
      value="top-rank"
      label="Top 5 in Rank"
      selected={value === 'top-rank'}
      changeHandler={changeHandler}
    />
    <TopBottomToggleOption
      value="bottom-rank"
      label="Bottom 5 in Rank"
      selected={value === 'bottom-rank'}
      changeHandler={changeHandler}
    />
    <TopBottomToggleOption
      value="top-improve"
      label="Top 5 in Improvement"
      selected={value === 'top-improve'}
      changeHandler={changeHandler}
    />
    <TopBottomToggleOption
      value="bottom-improve"
      label="Bottom 5 in Improvement"
      selected={value === 'bottom-improve'}
      changeHandler={changeHandler}
    />
  </div>
)

TopBottomToggle.propTypes = {
  value: PropTypes.string.isRequired,
  changeHandler: PropTypes.func.isRequired,
}

export default TopBottomToggle



// WEBPACK FOOTER //
// ./src/components/Visualizations/components/top-bottom-toggle.jsx